import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../services/category/category.service';
import { ActivatedRoute, NavigationExtras, ParamMap, Router } from '@angular/router';
import { ProductService } from "../services/product/product.service";
import { environment } from "../../environments/environment";
@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit {


    categories=[];
    fournisseurs=[];
    productByCategory;
    pageSize = 12;
    page;
    total;
    contentLoaded = false;
    listF1=[];
    listF2=[];
    listF3=[];
    listF3Filtre = [];
    listFN = [];
    subCategories = [];
    baseUrl = environment.baseUrl
    defaultParent:any;
    fileTitiles = {f1:"",f2:"",f3:""}
    checkedFournisseurs:any=[];
    startIndex = 1;
    totalPages = 0;
    itemsPerPage = 12;
    pageNumbers:any;
    constructor(private categoryService:CategoryService,private route: ActivatedRoute,private productService:ProductService,private router: Router) { }

    nextPage() {
      if (this.startIndex < this.totalPages) {
        this.startIndex++;
        const queryParams: NavigationExtras = {
          queryParams: {
            page: this.startIndex
          }
        };
        this.router.navigate([], queryParams);
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
        this.loadData();
      }
    }
  
    previousPage() {
      if (this.startIndex > 1) {
        this.startIndex--;
        const queryParams: NavigationExtras = {
          queryParams: {
            page: this.startIndex
          }
        };
        this.router.navigate([], queryParams);
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
        this.loadData();
      }
    }
  
    goToPage(pageNumber: number) {
      if (pageNumber >= 1 && pageNumber <= this.totalPages) {
        this.startIndex = pageNumber;
        const queryParams: NavigationExtras = {
          queryParams: {
            page: this.startIndex
          }
        };
        this.router.navigate([], queryParams);
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
        this.loadData();
      }
    }

    loadData() {
      this.route.paramMap.subscribe((params: ParamMap) => {
        var idParam = params.get('id')
        console.log(idParam);
        
        this.productService.productByCategory(idParam, this.startIndex,this.itemsPerPage,"TSICOD0").subscribe(res => {
           this.productByCategory = res['produits'];
          //  this.totalPages = Math.ceil(Number(res['total']) / this.itemsPerPage);
          // this.pageNumbers = Array.from({ length: this.totalPages }, (_, i) => i + 1);
          this.totalPages = Math.ceil(Number(res['total']) / this.itemsPerPage);
          if (this.totalPages > 10) {
            if (
              Number(this.startIndex) <= this.totalPages - 5 &&  Number(this.startIndex) > this.totalPages - 5 || 
              Number(this.startIndex) <= this.totalPages - 4 &&  Number(this.startIndex) > this.totalPages - 5 ||
              Number(this.startIndex) <= this.totalPages - 3 &&  Number(this.startIndex) > this.totalPages - 5 ||
              Number(this.startIndex) <= this.totalPages - 2 &&  Number(this.startIndex) > this.totalPages - 5 ||
              Number(this.startIndex) <= this.totalPages - 1 &&  Number(this.startIndex) > this.totalPages - 5 ||
              Number(this.startIndex) <= this.totalPages &&  Number(this.startIndex) > this.totalPages - 5
              ) {
              this.pageNumbers = [
                1, 2 , '...', this.totalPages - 4,  this.totalPages - 3,  this.totalPages - 2,  this.totalPages - 1,  this.totalPages
              ];
            } else {
              if (Number(this.startIndex) > 2) {
                this.pageNumbers = [
                  1, 2 , '...', this.startIndex, Number(this.startIndex)+1, Number(this.startIndex)+2, Number(this.startIndex)+3, Number(this.startIndex)+4, '...', this.totalPages - 1, this.totalPages
                ];
              } else {
                this.pageNumbers = [
                  this.startIndex, Number(this.startIndex)+1, Number(this.startIndex)+2, Number(this.startIndex)+3, Number(this.startIndex)+4, '...', this.totalPages - 1, this.totalPages
                ];
              }
            }
          } else {
            this.pageNumbers = Array.from({ length: this.totalPages }, (_, i) => i + 1);
          }
           this.fournisseurs = res['fournisseurs'];
           this.total = this.productByCategory.length;
           this.contentLoaded = true;
         });

        //  this.categoryService.allCategories().subscribe(res =>{
        //    this.listF1=[];
        //    this.listF2=[];
        //    this.listF3=[];
        //    this.listFN=[];
        //    this.categories = res['categories'];
        //    this.formatDataCategories(this.categories);
        //    var categorySelected = this.listF3.filter(function(f3) {
        //      if (f3.id === idParam) {
        //        return f3;
        //      }
        //    });
        //    this.filtreF3ByF2(idParam);
        //    console.log(this.listF2)
        //    var lstF2Filtre = this.listF2.filter((f2)=>{
        //      if(f2.parent == idParam){
        //        return f2;
        //      }
        //    })

        //    var lstF1Filtre = this.listF1.filter((f1)=>{
        //      if(f1.id == idParam){
        //        return f1;
        //      }
        //    })

        //    //this.listF2 = lstF2Filtre;
        //    this.defaultParent = idParam;
        //    this.fileTitiles.f1 = lstF1Filtre[0].titre
           
        //    lstF2Filtre.forEach((item)=>{
        //     if(item.categories != null){
        //       var arr = Object.entries(item.categories)
        //       this.listFN.push({'id':arr[0][0],'title':arr[0][1]})
        //     }
        //    })
        //    this.categoryService.allSubCategories().subscribe(res =>{
        //     var subCategoriesTemp = res['categories'][this.defaultParent]
            
        //     for(var k in subCategoriesTemp){
        //       this.subCategories.push({id:k,titre:subCategoriesTemp[k]})
        //     }
        //     console.log("sub",this.subCategories);
            
        //   })
           
           
        //  })
        this.categoryService.allCategoriesByNv('nv0',idParam).subscribe(res =>{
          console.log(res);
          this.fileTitiles.f1 = res['titre']
          for(var k in res['categories']){
            this.subCategories.push({"id":k,"titre":res['categories'][k]}) 
          }
          
        })

      });
    }

    ngOnInit(): void {
      this.route.queryParams.subscribe(params => {
        if (params['page']) {
          this.startIndex = params['page']
        }
      })
      this.loadData();
  }


    changeMax(nbrProducts)
    {
      // this.pageSize = nbrProducts;
      this.itemsPerPage = nbrProducts;
      this.loadData();
    }

    filtreByFournisseur(event:any)
    {

      if (this.checkedFournisseurs.filter(f => f == event.target.value).length == 0) {
        this.checkedFournisseurs.push(event.target.value);
      }else{
        const index = this.checkedFournisseurs.indexOf(event.target.value);
        if (index > -1) {
          this.checkedFournisseurs.splice(index, 1);
        }
      }

      let idParam = this.route.snapshot.paramMap.get('id');
      if (this.checkedFournisseurs.length == 0) {
        this.productService.productByCategory(idParam,this.startIndex,this.itemsPerPage,"TSICOD0").subscribe(res => {
          this.productByCategory = res['produits'];
          // this.fournisseurs = [...new Set(res['fournisseurs'])];
   
          this.total = this.productByCategory.length;
          this.contentLoaded = true;
        });
      }else {
        this.productService.productByCategory(idParam,this.startIndex,this.itemsPerPage, "TSICOD0",this.checkedFournisseurs).subscribe(res => {
           this.productByCategory = res['produits'];
           // this.fournisseurs = [...new Set(res['fournisseurs'])];
    
           this.total = this.productByCategory.length;
           this.contentLoaded = true;
         });
      }  

    }

    filtreF3ByF2(f2Id)
    {
      this.listF3Filtre = [];

      this.listF3Filtre = this.listF3.filter(function(f3) {
        if (f3.parent === f2Id) {
          return f3;
        }

      });

    }

    formatDataCategories(categories)
  {
    
    var objectTemp = {id:'',titre:'',categories:{},parent:null};
    for (var i in categories)
    {
      
      objectTemp = categories[i];
      objectTemp.id = i.toString();
      this.listF1.push(objectTemp);
    }
    

    var f2Temp;
    this.listF1.forEach(f1 => {
      console.log(f1);
      
      f2Temp = f1.categorie;
      
      for( var i in f2Temp ) 
      {

        objectTemp = f2Temp[i];
        objectTemp.id = i;
        objectTemp.parent =  f1.id;
        this.listF2.push(objectTemp);
      }
    });

    var f3Temp;
    this.listF2.forEach(f2 => {

      if (f2.categories != undefined && f2.categories.length!=0  ) {

        f3Temp =f2.categories;
        
        for (var i in f3Temp)
        {
          console.log(f3Temp[i]);
          
          objectTemp.titre = f3Temp[i];
          objectTemp.id = i;
          objectTemp.parent =  f2.id;
          this.listF3.push(objectTemp);
          objectTemp = {id:'',titre:'',categories:{},parent:null};
        }
      }
    });

  }
}
